import {Component, Input, OnInit} from '@angular/core';
import {OrderService} from "../../../services/order.service";
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {ToastrService} from "ngx-toastr";

@Component({
    selector: 'app-confirm-order-modal',
    templateUrl: './confirm-order-modal.component.html',
    styleUrls: ['./confirm-order-modal.component.scss']
})
export class ConfirmOrderModalComponent implements OnInit {

    @Input() order;
    loading = false;
    constructor(
        private orderService: OrderService,
        public activeModal: NgbActiveModal,
        private toastrService: ToastrService,
    ) { }

    ngOnInit(): void {
    }

    confirm() {
        this.loading = true;
        let status = 8;
        this.orderService.statusOrder(this.order.id, status)
            .subscribe({
                next: response => {
                    this.loading = false;
                    this.toastrService.success(response.message);
                    this.activeModal.close();
                },
                    error: err => {
                    this.loading = false;
                    this.toastrService.error(err);
                }
            });
    }

    cancel() {
        this.loading = true;
        let status = 4;
        this.orderService.statusOrder(this.order.id, status)
            .subscribe({
                next: response => {
                    this.loading = false;
                    this.toastrService.success(response.message);
                    this.activeModal.close();
                },
                error: err => {
                    this.loading = false;
                    this.toastrService.error(err);
                }
            });
    }

}
